import React, {useEffect} from 'react';
import {Route, Redirect} from 'react-router-dom';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import Axios from 'axios';
import {Configs} from '../../configs/general.config';
import jwt_decode from 'jwt-decode';

function PrivateRoute({render, ...rest}) {
	const dispatch = useDispatch();
	const {singIn} = useSelector(
		(state) => ({
			singIn: state.login
		}),
		shallowEqual
	);

	let {login} = {...singIn};

	const checkToken = async (data) => {
		let results = false;
		try {
			await Axios({
				method: 'post',
				url: `${Configs.urlApi}/api/${Configs.typeApi}/v1/authenticator/check-token`,
				data: {token: data},
				headers: {
					Authorization: `Bearer ${Configs.BearerToken}`
				}
			})
				.then(() => {
					results = true;
				})
				.catch(() => {
					localStorage.clear();
					dispatch({
						type: 'LOGIN_USER_RETURN',
						payload: []
					});
				});
		} catch (error) {
			localStorage.clear();
			dispatch({
				type: 'LOGIN_USER_RETURN',
				payload: []
			});
		}

		return results;
	};

	useEffect(() => {
		if (login && Object.keys(login).length !== 0) {
			checkToken(login.data.token);
		}
	}, [login]); // eslint-disable-line react-hooks/exhaustive-deps

	const isAuth = () => {
		if (login && Object.keys(login).length !== 0) {
			return true;
		} else {
			return false;
		}
	};

	const is_admin = () => {
		if (login && login.data) {
			const userInfo = jwt_decode(login.data.token);
			if (userInfo.role === 3 || userInfo.role === 2) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	};

	const renderContent = () => {
		if (!isAuth()) return () => <Redirect to="/login" />;
		if (!is_admin()) return () => <Redirect to="/" />;
		return render;
	};

	return <Route {...rest} render={renderContent()} />;
}

export default PrivateRoute;
